// @flow
export const PLATFORM_WINDOWS = 'PLATFORM_WINDOWS';
export const PRODUCT_ADMIN = 'admin';



// WEBPACK FOOTER //
// ./src/portfolio-shared/util/sharedConstants.js